'use client';

/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */

// Lib dependencies
import omit from 'lodash/omit';
import { modals } from '@mantine/modals';

// Type
import { PromptDeleteArgs } from './types';
import { PROMPT_BASE_PRESETS } from '../presets';

// Style
import * as classes from '../styles.css';
import Prompt from '../Prompt';
import { DeleteAction } from '@app/types/blackroom-api';

let modalNextId = 1;

const invokePromptDelete = ({ componentProps, ...args }: PromptDeleteArgs) => {
  const modalId = `prompt:delete:${(modalNextId += 1)}`;
  const color = 'blackroomRed';

  modals.open({
    ...PROMPT_BASE_PRESETS,
    modalId,
    withCloseButton: false,
    classNames: {
      body: classes.body,
    },
    children:
      'modalContent' in componentProps ? (
        <Prompt
          modalId={modalId}
          color={color}
          onConfirm={args.onConfirm}
          {...componentProps}
        >
          {componentProps.modalContent}
        </Prompt>
      ) : (
        <Prompt
          modalId={modalId}
          color={color}
          onConfirm={args.onConfirm}
          i18nKey="Common:prompts.promptDelete.prompt"
          i18nValues={{
            entityLabel: componentProps.entityLabel,
            deleteAction:
              componentProps.deleteAction === DeleteAction.Remove
                ? 'delete'
                : 'archive',
          }}
          {...componentProps}
        />
      ),
    trapFocus: true,
    ...omit(args, 'onConfirm'),
  });
};

export default invokePromptDelete;
